export function formatLongDate(item, isNumber = false) {
    if (!item) return '';

    const currentLanguage = localStorage.getItem('eahsLang') ?? 'en';
    const isEnglish = currentLanguage === 'en';

    let s = String(item).trim();
    const isPureDate = /^(19|20)\d{2}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/.test(s);
    if (isPureDate) {
        s = s + 'T00:00:00+04:00';
    } else if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(:\d{2})?(\.\d+)?$/.test(s)) {
        s = s + '+04:00';
    }
    const incomingDate = new Date(s);

    if (isNumber) {
        const parts = new Intl.DateTimeFormat('en-CA', {
            timeZone: 'Asia/Dubai',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            hour12: true
        }).formatToParts(incomingDate);
        const get = t => parts.find(p => p.type === t)?.value;
        const dd = get('day');
        const mm = get('month');
        const yyyy = get('year');
        let timeStr = '';
        if (!isPureDate) {
            const h = get('hour');
            const min = get('minute');
            const dayPeriod = parts.find(p => p.type === 'dayPeriod')?.value;
            const ampm = dayPeriod?.toLowerCase() === 'pm' ? (isEnglish ? 'PM' : 'م') : (isEnglish ? 'AM' : 'ص');
            timeStr = ` ${h}:${min} ${ampm}`;
        }
        return `${dd}/${mm}/${yyyy}${timeStr}`;
    }

    const dateOptions = {
        timeZone: 'Asia/Dubai',
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
        ...(!isPureDate && {
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
        }),
    };

    return incomingDate.toLocaleString(isEnglish ? 'en-US' : 'ar-EG-u-nu-latn', dateOptions);
}
